import { render, staticRenderFns } from "./dashboard-composition.vue?vue&type=template&id=35afccd0&scoped=true&"
import script from "./dashboard-composition.vue?vue&type=script&lang=js&"
export * from "./dashboard-composition.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-composition.vue?vue&type=style&index=0&id=35afccd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35afccd0",
  null
  
)

export default component.exports